var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0797 3.03719C7.86232 2.01695 6.0485 2.16361 5.12484 3.45579C4.87812 3.80094 4.58577 4.2126 4.08082 4.84424C2.34375 7.01714 2.34376 10.1634 4.09042 12.3286C5.37984 13.927 6.73178 15.5398 8.24307 17.0511C9.75437 18.5624 11.3672 19.9144 12.9656 21.2038C15.1308 22.9504 18.2771 22.9504 20.45 21.2134C21.1239 20.6746 21.5443 20.381 21.9012 20.1262C23.1494 19.2348 23.3243 17.4863 22.3496 16.302C21.5794 15.3661 20.7219 14.4732 19.8945 13.6017C19.2355 12.9074 18.1348 12.8621 17.3868 13.4594C17.1856 13.6201 16.9358 13.8319 16.4294 14.3067C13.9439 12.8298 12.4375 11.305 10.9875 8.86483C11.4681 8.35221 11.6801 8.10169 11.8421 7.89856C12.4384 7.15114 12.3942 6.05334 11.6958 5.40027C10.8446 4.60432 9.97839 3.79036 9.0797 3.03719Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 2.57143,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c8a7e8864868021e1e4d5a680ce1922b.svg";
export { ForwardRef as ReactComponent };